import { render, staticRenderFns } from "./ModalBar.vue?vue&type=template&id=1c511c20&"
import script from "./ModalBar.vue?vue&type=script&lang=js&"
export * from "./ModalBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports